import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link as RouterLink } from "react-router-dom";

import {
  faRoad,
  faGasPump,
  faCogs,
  faArrowUpRightFromSquare,
  faBookmark,
  faCarSide,
  faPalette,
} from "@fortawesome/free-solid-svg-icons";
import carFax from "../assets/images/Logo_NoBadges.svg"
import { faTrash } from "@fortawesome/free-solid-svg-icons"; // Add trash icon

const CardWrapper = styled.div`
  border-radius: 20px;
  background: #fff;
  height:530px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  position: relative;
  width: 320px;
  transition: transform 0.2s ease;
  &:hover {
    transform: translateY(-4px);
  }
  @media (max-width: 768px) {
    width: 100%;
    border-radius: 12px;


  }
`;

const Label = styled.div`
  position: absolute;
  top: 16px;
  left: 16px;
  background-color: #2ecc71;
  color: white;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 600;
`;

const Bookmark = styled.div`
  position: absolute;
  top: 276px;
  right: 16px;
  background: #e61717;
  height: 36px;
  border-radius: 20px;
  color:#fff;
  display: flex;
  padding:10px 15px;
  gap:5px;
  border:1px solid white;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  cursor: pointer;

  p{
    color:#fff;
    font-family:var(--font-medium)

  }
  svg{
    color:#fff;

  }
`;


const Fixed = styled.div`
  position: absolute;
  bottom: 10px;
  background: white;
  width: 95%;
 left:2.5%;
//  height:50px;
  cursor: pointer;
`;

const Image = styled.img`
  width: 100%;
  height:220px;
  object-fit: cover;
`;

const Bottom = styled.div`
  background: #fff;
  color: #1e293b;
  padding: 13px;
  margin-top: -13px;
`;
const Bottom2 = styled.div`
  background: #fff;
  color: #1e293b;
  margin-top: -7px;
`;


const Title = styled.h3`
  margin: 0;
  text-transform: uppercase;
  margin-top:10px;

  font-size: 17px;
  color: #111827;
`;

const Title3 = styled.h3`
  margin: 0;
margin-top:-6px;
  font-size: 13px;
  color: #979797;
`;

const Title2 = styled.h3`
  margin: 0;
  margin-top:-6px;

  font-family: var(--font-bold);
  font-size: 19px;
  color: #111827;
`;

const SubTitle = styled.p`
  font-size: 0.85rem;
  color: #6b7280;
  margin: 4px 0 12px;
`;

const InfoRow = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr); /* 4 equal columns */
  gap: 0; /* Remove gaps to handle borders cleanly */
  margin: 10px 0 10px;
  border-left: none; /* Avoid double border effect */
  border-right: none;
`;
const InfoItem = styled.div`
  position: relative;
  padding: 12px 8px;
  text-align: center;
  font-size: 12px;
  color: #374151;

  display: grid;
  place-items: center;

  &:not(:first-child)::before {
    content: '';
    position: absolute;
    left: 0;
    top: 25%;
    height: 50%;
    border-left: 1px solid #e5e7eb;
  }

  svg {
    margin-bottom: 4px;
    font-size: 18px;
    color: #4b5563;
  }

  span {
    display: block;
    max-width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;





const PriceRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
  padding:0px 10px;
`;



const Price = styled.strong`
  font-size: 1.25rem;
  color: #e61717;
`;

const Link = styled.a`
  color: #e61717;
  text-decoration: none;
  font-size: 0.95rem;
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
`;

const Submit = styled.button`
  background-color: #e61717;
  text-decoration: none;
  font-size: 15px;
  border:none;
  text-align: center;
  gap: 4px;
  color:white;
  font-family: var(--font-semiBold);
  padding: 10px 17px;  width:100%;
  cursor: pointer;
`;

type VehicleProps = {
  id: string;
carfax:string;
  make: string;
  model: string;
  year: number;
  km: number;
  price: string;
  fuel: string;
  trim:string;
  transmission: string;
  drivetrain: string;
  extColor: string;
  description: string;
  label?: string;
  imgUrl: string;
  onDelete?: (id: string) => void; // Add onDelete prop

};

const VehicleCard = ({
  id,
  make,
  model,
  year,
  km,
  trim,
  price,
  drivetrain,
  transmission,
  extColor,
  imgUrl,
  carfax,
  onDelete,

}: VehicleProps) => {
  return (
    <CardWrapper>
   
      <Image src={imgUrl} alt={`${make} ${model}`} />
      <Bottom2>
 <Submit  onClick={() => { window.location.href = "./pre-approval"; }}>Get Pre-Approved</Submit>      </Bottom2>

      <Bottom>
        <Title>{`${make}`}</Title>
        <Title2>{`${year} ${model} `}</Title2>
        <Title3>{`${trim} `}</Title3>

        <InfoRow>
  <InfoItem>
    <FontAwesomeIcon icon={faRoad} />
    <span>{km.toLocaleString()} KM</span>
  </InfoItem>
  <InfoItem>
    <FontAwesomeIcon icon={faCogs} />
    <span>{transmission}</span>
  </InfoItem>
  <InfoItem>
    <FontAwesomeIcon icon={faCarSide} />
    <span>{drivetrain}</span>
  </InfoItem>
  <InfoItem>
    <FontAwesomeIcon icon={faPalette} />
    <span>{extColor}</span>
  </InfoItem>
</InfoRow>


{carfax && carfax !== "-" && (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
    <a href={carfax}>
      <img src={carFax} style={{ width: 70 }} />
    </a>
  </div>
)}


       <Fixed>
       <hr style={{border:'none',borderBottom:'1px solid #ddd'}}/>

       
        <PriceRow>
        {price === '-' ? (
  <div>
    <div style={{ fontSize: '16px',marginTop:-0, color: '#555' }}>Call for <br/>Pricing</div>
  </div>
) : (
  <div>
    <Price>${price}</Price>
    <div style={{ fontSize: '13px',marginTop:-5, color: '#555' }}>+ Tax & Licensing</div>
  </div>
)}
      <RouterLink to={`/vehicle/${id}`} style={{ color: '#e61717', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '4px' }}>
  View Details <span>↗</span>
</RouterLink>
        
        </PriceRow>
        </Fixed>
      </Bottom>
    </CardWrapper>
  );
};

export default VehicleCard;
